<ng-container *ngIf="state as ipDetails">
    <div
        class="anq-section-wrapper-border d-flex flex-column flex-md-row align-items-center justify-content-between p-3 gap-3 mb-4"
        *ngIf="ipDetails.showWarningBox"
    >
        <div>
            <h2 class="mb-1 d-flex align-items-center gap-2">
                <i class="bi bi-exclamation-circle text-dark" style="font-size: 20px;"></i>
                <span>Attention</span>
            </h2>
            <p class="m-0">{{ ipDetails.attentionMessage }}</p>
        </div>

        <a
            *ngIf="ipDetails.showProfileButton"
            class="anq-btn anq-btn-secondary sm-radius"
            routerLink="/profile"
            fragment="verification"
        >Upload Documents</a>

        <button
            *ngIf="ipDetails.showIPWhitelistRequestButton"
            class="anq-btn anq-btn-secondary sm-radius"
            type="button"
            (click)="requestWhitelist.emit()"
        >Request IP Whitelisting</button>
    </div>
</ng-container>